<template>
  <div
    v-if="current"
    class="d-none d-md-flex flex-column bg-white border"
    style="position:fixed;bottom:140px;right:16px;z-index:1030;border-radius:12px;padding:10px 12px;border-color:#e9ecef !important;box-shadow:0 4px 16px rgba(0,0,0,.1);font-size:12px;max-width:280px;cursor:pointer;border-left:4px solid #fd4719 !important;"
    @click="navigate"
  >
    <div class="d-flex align-items-center">
      <span class="rounded-circle d-inline-flex align-items-center justify-content-center mr-2" style="width:22px;height:22px;flex:0 0 auto;background-color:#fd4719;">
        <i class="bi bi-credit-card text-white" style="font-size:11px;"></i>
      </span>
      <div class="flex-grow-1">
        <div class="text-dark font-weight-bold">Payment received &middot; {{ current.provider || 'Mobile Money' }}</div>
        <div class="font-weight-bold" style="color:#fd4719;">{{ convertCurrencyToLocal(current.amount) }}</div>
        <div v-if="current.transaction_code" class="text-muted"><small>{{ current.transaction_code }}</small></div>
      </div>
      <span v-if="queue.length > 0" class="badge badge-secondary ml-2" style="align-self:flex-start;">+{{ queue.length }}</span>
      <button
        type="button"
        class="btn btn-link text-muted p-0 ml-2"
        style="font-size:14px;line-height:1;"
        aria-label="Dismiss"
        @click.stop="dismiss"
      ><i class="bi bi-x"></i></button>
    </div>
  </div>
</template>

<script>
import { getEcho } from "../../services/echo";

const AUTO_HIDE_MS = 8000;

export default {
  name: "GlobalPaymentBadge",
  data() {
    return {
      queue: [],
      current: null,
      channelName: null,
      timer: null,
    };
  },
  methods: {
    resolveCompanyId() {
      try {
        const userDetails = JSON.parse(window.localStorage.getItem("userDetails"));
        return (userDetails && userDetails.company && userDetails.company.id) || null;
      } catch (e) {
        return null;
      }
    },
    subscribe() {
      if (this.channelName) return;
      const companyId = this.resolveCompanyId();
      if (!companyId) return;

      this.channelName = `company.${companyId}.payments`;
      getEcho().private(this.channelName).listen(".payment.received", (payload) => {
        this.enqueue(payload);
      });
    },
    enqueue(payload) {
      if (this.current) {
        this.queue.push(payload);
      } else {
        this.show(payload);
      }
    },
    show(payload) {
      this.current = payload;
      clearTimeout(this.timer);
      this.timer = setTimeout(this.advance, AUTO_HIDE_MS);
    },
    advance() {
      clearTimeout(this.timer);
      this.current = this.queue.length ? this.queue.shift() : null;
      if (this.current) {
        this.timer = setTimeout(this.advance, AUTO_HIDE_MS);
      }
    },
    dismiss() {
      this.advance();
    },
    navigate() {
      window.location.href = "/payment-transactions/sms-sync";
    },
  },
  mounted() {
    this.subscribe();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    if (this.channelName) {
      getEcho().leave(this.channelName);
    }
  },
};
</script>
